;(function (algolia) {
  "use strict"

  console.log("assets are still loading")

  // Algolia template files, need to be loaded in first to prevent errors ===========================================================>

  // algolia_autocomplete.liquid ===========================================================>

  algolia.mainTemplate = function mainTemplate({ html, state }, elements, displaySuggestions, showArticles) {
    // adding in custom functionality to instant search
    let input = document.querySelector(".aa-DetachedOverlay .aa-Input")
    let form = document.querySelector(".aa-DetachedOverlay .aa-Form")
    let clearButton = document.querySelector(".aa-DetachedOverlay .aa-ClearButton")
    let cancelButton = document.querySelector(".aa-DetachedOverlay .aa-DetachedCancelButton")
    // if the mobile input exists
    if (input) {
      // set the placeholder text
      input.setAttribute("placeholder", algolia.translations.search_placeholder_mobile)
      // change the clear button to the clear_search_mobile translation instead of SVG
      clearButton.innerHTML = algolia.translations.clear_search_mobile
      let closeButtonExists = document.querySelector(".aa-DetachedOverlay .aa-CloseButton")
      // check to see if the close button has already been added, if it hasnt, create it and add it to the form. On click, force click the cancel button
      // to close the search modal.
      if (!closeButtonExists) {
        let closeButton = document.createElement("button")
        closeButton.setAttribute("class", "aa-CloseButton")
        closeButton.addEventListener("click", function () {
          cancelButton.click()
        })
        form.append(closeButton)
      }
    }
    return html`<div class="aa-PanelLayout aa-Panel--scrollable">
      <div class="aa-PanelSections">
        <div class="aa-PanelSection--left">
          ${displaySuggestions &&
          html`<div class="aa-SourceHeader">
              <span class="aa-SourceHeaderTitle">${state.query && state.query.length > 0 ? "Suggested Searches" : "Trending Searches"}</span>
            </div>
            ${elements.redirectUrlPlugin} ${elements.querySuggestionsPlugin}`}
          <div class="aa-desktopOnly">${showArticles && elements.articles}</div>
        </div>
        <div class="aa-PanelSection--right">
          ${elements.products}
          <div class="aa-mobileOnly">${showArticles && elements.articles}</div>
        </div>
      </div>
    </div>`
  }

  // algolia_autocomplete.liquid ===========================================================>

  // algolia_autocomplete_main_products_only.liquid ===========================================================>

  algolia.mainProductsTemplate = function mainProductsTemplate({ html, state }, elements, displaySuggestions, showArticles) {
    return html`<div class="aa-PanelLayout aa-Panel--scrollable">
      <div class="aa-PanelSections">
        <div class="aa-PanelSection--left">
          ${displaySuggestions &&
          html`<div class="aa-SourceHeader">
              <span class="aa-SourceHeaderTitle">${state.query && state.query.length > 0 ? "Suggested Searches" : "Trending Searches"}</span>
            </div>
            ${elements.querySuggestionsPlugin}`}
          <div class="aa-desktopOnly">${showArticles && elements.articles}</div>
        </div>
        <div class="aa-PanelSection--right">
          ${elements.products}
          <div class="aa-mobileOnly">${showArticles && elements.articles}</div>
        </div>
      </div>
    </div>`
  }

  // algolia_autocomplete_main_products_only.liquid ===========================================================>

  // algolia_autocomplete_page.liquid ===========================================================>

  algolia.pagesTemplate = function pagesTemplate({ item, html, components }, itemLink) {
    return html`<a href="${itemLink}" class="aa-ItemLink aa-ProductItem">
      <div class="aa-ItemWrapper">
        <div class="aa-ItemContent">
          <div class="aa-ItemIcon aa-ItemIcon--noBorder">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <div class="aa-ItemContentBody">
            <div class="aa-ItemContentTitle">${components.Highlight({ hit: item, attribute: "title" })}</div>
          </div>
        </div>
      </div>
    </a>`
  }

  // algolia_autocomplete_page.liquid ===========================================================>

  // algolia_autocomplete_collection.liquid ===========================================================>

  algolia.collectionsTemplate = function collectionsTemplate({ item, html, components }, itemLink) {
    return html`<a href="${itemLink}" class="aa-ItemLink">
      <div class="aa-ItemWrapper">
        <div class="aa-ItemContent">
          <div class="aa-ItemIcon aa-ItemIcon--noBorder">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"
              />
            </svg>
          </div>
          <div class="aa-ItemContentBody">
            <div class="aa-ItemContentTitle">${components.Highlight({ hit: item, attribute: "title" })}</div>
          </div>
        </div>
      </div>
    </a>`
  }

  // algolia_autocomplete_collection.liquid ===========================================================>

  // algolia_autocomplete_article.liquid ===========================================================>

  algolia.articlesTemplate = function articlesTemplate({ item, html, components }, itemLink) {
    return html`<a href="${itemLink}" class="aa-ItemLink">
      <div class="aa-ItemWrapper">
        <div class="aa-ItemContent aa-ArticleItem">
          <img
            class="aa-ArticleItemImg"
            src="${algolia.helpers.compactImage(item)}"
            srcset="${algolia.helpers.imageSrcSet(item, false, false)}"
            sizes="(min-width: 1921px) 270w, (min-width: 769px) 180w, (min-width: 481px) and (max-width: 768px) 180w, (max-width: 480px) 180w, 350px"
            alt="${item.title}"
            loading="lazy"
          />
          <div class="aa-ItemContentBody">
            <div class="aa-ItemContentTitle">${components.Highlight({ hit: item, attribute: "title" })}</div>
          </div>
        </div>
      </div>
    </a>`
  }

  // algolia_autocomplete_article.liquid ===========================================================>

  // algolia_autocomplete_product.liquid ===========================================================>

  algolia.productTemplate = function productTemplate({ item, html, components, insights, state }, distinct, itemLink, getConversionData) {
    return html`<a href="${itemLink}" class="aa-ItemLink aa-ProductItem" onClick="${(event) => getConversionData(event, item)}">
      <div class="aa-ItemContent">
        <div class="aa-ItemPicture aa-ItemPicture--loaded">
          <img
            src="${algolia.helpers.compactImage(item)}"
            srcset="${algolia.helpers.imageSrcSet(item, false)}"
            sizes="(min-width: 1921px) 270w, (min-width: 769px) 180w, (min-width: 481px) and (max-width: 768px) 180w, (max-width: 480px) 180w, 350px"
            alt="${item.title}"
            loading="lazy"
          />
        </div>
        <div class="aa-ItemContentBody">
          <div class="aa-ItemContentTitleWrapper">
            <div class="aa-ItemContentTitle">${components.Highlight({ hit: item, attribute: "title" })}</div>
          </div>
          ${state.query && state.query.length > 0
            ? html`<div class="aa-ItemContentPrice">
                <div class="aa-ItemContentPriceCurrent">${algolia.helpers.displayPrice(item, distinct)}</div>
              </div>`
            : ""}
        </div>
      </div>
    </a>`
  }

  // algolia_autocomplete_product.liquid ===========================================================>

  // algolia_autocomplete_suggestion.liquid ===========================================================>

  algolia.suggestionsTemplate = function suggestionsTemplate({ item, html, components }) {
    return html`<a class="aa-ItemLink aa-ItemWrapper" href="/search?q=${item.query}">
      <div class="aa-ItemContent">
        <div class="aa-ItemContentBody">
          <div class="aa-ItemContentTitle">${components.Highlight({ hit: item, attribute: "query" })}</div>
        </div>
      </div>
      <div class="aa-ItemActions"></div>
    </a>`
  }

  // algolia_autocomplete_suggestion.liquid ===========================================================>

  // algolia_autocomplete_header.liquid ===========================================================>

  algolia.headerTemplate = function headerTemplate({ html, state }, resource) {
    let title = algolia.translation_helpers.render_title(resource, state.query)
    // console.log(state.query, title, state)
    if (title.startsWith("Products for")) {
      title = "Product results"
    } else if (title === "Products") {
      title = "Popular Styles"
    } else if (title === "Articles") {
      title = "Stories"
    }
    return html`<div class="aa-SourceHeader">
      <span class="aa-SourceHeaderTitle">${title}</span>
    </div>`
  }

  // algolia_autocomplete_header.liquid ===========================================================>

  // algolia_autocomplete_footer.liquid ===========================================================>

  algolia.footerTemplate = function footerTemplate({ html, state }, showArticlesText) {
    if (state.query === "") {
      return ""
    }
    let seeAllText, href, count
    if (showArticlesText) {
      count = state.context.nbArticles
      seeAllText = "View All " + count + " Stories"
      href = "/search?q=" + state.query + "&tab=blog"
    } else {
      count = state.context.nbProducts
      seeAllText = "View All " + count + " Products"
      href = "/search?q=" + state.query
    }
    return html`<div class="aa-footer">
      <a class="aa-SeeAllBtn" href="${href}"> ${seeAllText} </a>
    </div>`
  }

  // algolia_autocomplete_footer.liquid ===========================================================>

  // algolia_autocomplete_no_results.liquid ===========================================================>

  algolia.noResultsTemplate = function noResultsTemplate({ html, state }) {
    return html`<div class="aa-PanelLayout aa-Panel--scrollable">
      <p class="aa-NoResultsHeader">${algolia.translation_helpers.no_result_for(state.query)}</p>
      <a class="aa-NoResultsLink" href="/search?q="> ${algolia.translations.allProducts} </a>
    </div>`
  }

  // algolia_autocomplete_no_results.liquid ===========================================================>

  // algolia_instant_search.liquid ===========================================================>

  algolia.instantSearchMainTemplate = function instantSearchMainTemplate(html, data) {
    //console.log('data', data)
    return html`<div class="ais-page-loading" data-ais-page-loader><span class="splide__spinner"></span></div>
      <div class="ais-page">
        <div class="ais--title typo__subheading text-center">${algolia.translations.searchTitle}</div>
        <div class="ais--search-term h2 text-center">""</div>
        <div class="ais--view text-center">
          <button class="ais--view-products typo__subheading active">
            ${algolia.translations.products} (<span class="ais--view-products-count"></span>)
          </button>
          <button class="ais--view-blogs typo__subheading">${algolia.translations.articles} (<span class="ais--view-blogs-count"></span>)</button>
        </div>
        <div class="ais-products-container">
          <div class="ais-refinements-container">
            <div class="ais-clear-refinements-container"></div>
            <div class="ais-current-refined-values-container"></div>
          </div>
          <div class="ais--subtext typo__body-4 text-center hidden">${algolia.translations.noResultSubtext} ${" "}</div>
          <div class="ais-search-header">
            <div class="ais-facets-button" tabindex="0">filter</div>
            <div class="ais-sort">
              ${data.multipleSortOrders
                ? html`<div class="ais-sort-text">${algolia.translations.sortBy}</div>
                    <div class="ais-sort-orders-container"></div>`
                : html`<div class="ais-sort-text">${algolia.translations.sortBy}</div>
                    ${algolia.translations.relevance}`}
            </div>
            <div class="ais-stats-container"></div>
            <div class="ais-change-display">
              <span class="ais-change-display-model ais-change-display-selected" tabindex="0" aria-label="Display model photos">Model</span>|
              <span class="ais-change-display-product" tabindex="0" aria-label="Display product photos">Product</span>
            </div>
          </div>
          <div class="ais-main-container">
            <div class="ais-facets__overlay${algolia.helpers.isTabletUp() ? " ais-facets__shown" : ""}"></div>
            <div
              class="ais-facets${algolia.helpers.isTabletUp() && localStorage.getItem("algolia_filters_open") !== "false"
                ? " ais-facets__shown"
                : ""}"
            >
              ${data.facets.map(
                (facet) =>
                  html`<div class="ais-facet-dropdown-wrapper ais-facet-${facet.type} ais-facet-${facet.escapedName}">
                    <input class="ais-dropdown-checkbox" type="checkbox" id="${facet.escapedName}" name="dropdown" />
                    <label for="${facet.escapedName}" class="ais-range-slider--header ais-facet--header ais-header">${facet.title}</label>
                    <div class="ais-facet-${facet.escapedName}-container ais-facet-dropdown-container"></div>
                  </div>`
              )}
              <button class="ais-facets__apply-button">Apply Filters (<span class="ais-facets__apply-button-count">0</span>)</button>
            </div>
            <div class="ais-block">
              <div class="ais-hits-container ais-results-as-block"></div>
              <div class="ais-input hidden">
                <div class="ais-search-container">
                  <div class="ais-search-box-container"></div>
                  <div class="ais-input-button">
                    <div class="ais-clear-input-icon"></div>
                  </div>
                </div>
              </div>
              <div class="ais-trending-searches text-center hidden">
                <div class="ais-hit-empty--trending-searches-title typo__subheading">${algolia.translations.trendingSearches} ${" "}</div>
                <div class="ais-hit-empty--trending-searches"></div>
              </div>
              <div class="ais-pagination-container"></div>
              ${algolia.is_collection_results_page
                ? html`<div class="collection-description-container container">
                    <div class="row">
                      <div class="col-12">
                        <div class="collection__description-header typo__body-2">${window.custom_seo_title}</div>
                        <div class="collection__description typo__body-4">${window.collection_description}</div>
                      </div>
                    </div>
                  </div>`
                : null}
            </div>
          </div>
        </div>
        <div class="ais-blogs-container hidden">
          <div class="ais-search-header">
            <div class="ais-sort">
              ${data.multipleSortOrders
                ? html`${algolia.translations.sortBy} <span class="ais-sort-orders-blogs-container"></span>`
                : html`${algolia.translations.sortBy} ${algolia.translations.relevance}`}
            </div>
          </div>
          <div class="ais-main-blogs"></div>
        </div>
      </div>`
  }

  // algolia_instant_search.liquid ===========================================================>

  // algolia_instant_search_stats.liquid ===========================================================>

  algolia.instantSearchStatsTemplate = function instantSearchStatsTemplate(data, html) {
    return html`${data.hasNoResults && algolia.translations.noResultFound}
    ${data.hasOneResult && html`<span class="ais-stats--nb-results"> ${algolia.translations.oneResultFound} </span>`}
    ${data.hasManyResults &&
    html` <span class="ais-stats--nb-results">
      ${" "} ${algolia.helpers.formatNumber(data.nbHits)} ${" "} ${algolia.translations.resultsFound}
    </span>`}`
  }

  // algolia_instant_search_stats.liquid ===========================================================>

  // algolia_instant_search_facet_show_more.liquid ===========================================================>

  algolia.instantSearchShowMore = function instantSearchShowMore(data, html) {
    return html`<span>${data.isShowingMore ? algolia.translations.showLess : algolia.translations.showMore}</span>`
  }

  // algolia_instant_search_facet_show_more.liquid ===========================================================>

  // algolia_instant_search_facet_item.liquid ===========================================================>

  algolia.instantSearchFacetItem = function instantSearchFacetItem(item, html) {
    return html`<label class="${item.cssClasses.label}">
        ${item.type === "disjunctive" &&
        (item.isRefined
          ? html`<input type="checkbox" class="${item.cssClasses.checkbox}" checked />`
          : html`<input type="checkbox" class="${item.cssClasses.checkbox}" />`)}
        ${item.label.includes("#") ? item.label.split("||")[1] : item.label}
        <span class="${item.cssClasses.count}"> ${algolia.helpers.formatNumber(item.count)} </span>
      </label>
      ${item.label.includes("#")
        ? html`<span class="ais-RefinementList-item--color-swatch" style="background-color:${item.label.split("||")[0]};"></span>`
        : ``}`
  }

  // algolia_instant_search_facet_item.liquid ===========================================================>

  // algolia_instant_search_no_result.liquid ===========================================================>

  algolia.instantSearchNoResultTemplate = function instantSearchNoResultTemplate(html, results) {
    //console.log('results', results)
    document.querySelector(".ais-search-header").classList.add("hidden")
    document.querySelector(".ais-input").classList.remove("hidden")
    document.querySelector(".ais--subtext").classList.remove("hidden")
    document.querySelector(".ais-trending-searches").classList.remove("hidden")
    document.querySelector(".ais-hits-container").classList.add("hidden")
    document.querySelector(".ais--view").classList.add("hidden")
    document.querySelector(".ais-facets").classList.add("hidden")
    return html`<div class="ais-hit-empty">
      <div class="ais-hit-empty--title typo__subheading">${algolia.translations.noResultFound}</div>
      <div class="ais-hit-empty--search-term h2">"${results.query}"</div>
      <div class="ais-hit-empty--subtext typo__body-4">${algolia.translations.noResultSubtext} ${" "}</div>
    </div>`
  }

  // algolia_instant_search_no_result.liquid ===========================================================>

  // algolia_instant_search_blogs.liquid ===========================================================>

  algolia.instantSearchBlogsTemplate = function instantSearchBlogsTemplate(hit, html, components) {
    //console.log('hit', hit)
    const bodyExcerpt = hit.body_html_safe.substring(0, 150)
    if (hit.meta.custom && hit.meta.custom.subhead_label != undefined) {
      return html`<a class="ais-blog-article" href="/blogs/${hit.blog.handle}/${hit.handle}">
        <div class="ais-blog-article--image">
          <img
            src="${algolia.helpers.grandeImage(hit)}"
            srcset="${algolia.helpers.imageSrcSet(hit)}"
            sizes="(min-width: 1921px) 900w, (min-width: 769px) 540w, (min-width: 481px) and (max-width: 768px) 450w, (max-width: 480px) 360w, 900px"
            alt="${hit.title}"
            loading="lazy"
          />
        </div>
        <div class="ais-blog-article--title typo__subheading">${algolia.helpers.blogSubheadLabel(hit)}</div>
        <div class="ais-blog-article--subhead h4">${hit.title}</div>
        <div class="ais-blog-article--excerpt typo__body-2">${bodyExcerpt}</div>
      </a>`
    } else {
      return html`<a class="ais-blog-article" href="/blogs/${hit.blog.handle}/${hit.handle}">
        <div class="ais-blog-article--image">
          <img
            src="${algolia.helpers.grandeImage(hit)}"
            srcset="${algolia.helpers.imageSrcSet(hit)}"
            sizes="(min-width: 1921px) 900w, (min-width: 769px) 540w, (min-width: 481px) and (max-width: 768px) 450w, (max-width: 480px) 360w, 900px"
            alt="${hit.title}"
            loading="lazy"
          />
        </div>
        <div class="ais-blog-article--subhead h4">${hit.title}</div>
        <div class="ais-blog-article--excerpt typo__body-2">${bodyExcerpt}</div>
      </a>`
    }
  }

  // algolia_instant_search_blogs.liquid ===========================================================>

  // algolia_instant_search_blogs_empty.liquid ===========================================================>

  algolia.instantSearchBlogsEmptyTemplate = function instantSearchBlogsEmptyTemplate(html, results) {
    document.querySelector(".ais--view-blogs").disabled = true
  }

  // algolia_instant_search_blogs_empty.liquid ===========================================================>

  // End Algolia template files ===========================================================>

  // algolia_init.js.liquid ================================================================>

  if (algolia.config.powered_by) {
    // eslint-disable-next-line no-console
    console.log("You're using Algolia !\n" + "Visit https://www.algolia.com/ for more insight about what we do.")
  }

  /* Store variables */
  algolia.storeName = window.location.hostname.replace(/^www\./, "").replace(/^([^.]*)\..*$/, "$1")

  /**
   * Checks whether we are on the `/search` page
   */
  algolia.full_results = Boolean(window.location.href.match(/\/search/))

  /**
   * Checks whether we are on a collection page
   */
  algolia.is_collection_results_page = Boolean(
    // We want to match `/collections/handle` but only if handle != 'all'
    window.location.pathname.match(/^\/collections\/([^/]+)[/]*$/)
    /**
     * To match /collections/handle/handle-two links as well, please use
     * the following regex instead:
     */
    // window.location.pathname.match(/^\/collections\/(?!all)(.*)$/)
  )

  /* Hide page content during InstantSearch loading */
  var collectionPageEnabled = algolia.is_collection_results_page && algolia.config.instant_search_enabled_on_collection
  var results_selector = collectionPageEnabled ? algolia.config.collection_css_selector : algolia.config.results_selector
  results_selector += ", .algolia-shopify-instantsearch"

  if ((algolia.full_results && algolia.config.instant_search_enabled) || collectionPageEnabled) {
    algolia.contentHide = new DOMParser().parseFromString(
      "<style>" + results_selector + " { visibility: hidden }</style>",
      "text/html"
    ).head.firstElementChild
    document.head.append(algolia.contentHide)
  }

  algolia.getTemplate = function getTemplate(name) {
    var el = document.getElementById("template_algolia_" + name)
    return el ? el.innerHTML : ""
  }

  // Current collection page ID
  var current_collection_id_string = algolia.getTemplate("current_collection_id").replace(/^\s+|\s+$/g, "")

  if (current_collection_id_string) {
    try {
      var current_collection_id_object = JSON.parse(current_collection_id_string)
      algolia.current_collection_id = current_collection_id_object.currentCollectionID
    } catch (error) {
      // Encountered an error while trying to parse the collection ID.
      // This most probably means that we aren't on a collection page.
    }
  }

  /* Add CSS block after current script */
  algolia.appendStyle = function appendStyle(content) {
    var scripts = document.getElementsByTagName("script")
    var currentScript = scripts[scripts.length - 1]
    var style = document.createElement("style")
    style.innerHTML = content
    currentScript.parentNode.insertBefore(style, currentScript.nextSibling)
  }

  algolia.assign = function assign(to) {
    for (var i = 1; i < arguments.length; i++) {
      var nextSource = arguments[i]
      for (var nextKey in nextSource) {
        if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
          to[nextKey] = nextSource[nextKey] // eslint-disable-line no-param-reassign
        }
      }
    }
    return to
  }

  /* Here because we need to ensure we have a fallback with . */
  algolia.money_format = algolia.getTemplate("money_format").replace(/^\s+|\s+$/g, "")
  algolia.formatMoney = function formatMoney(cents) {
    var priceInCents = cents

    /**
     * Uncomment the following block to support Shopify multi currency
     * and convert prices from store currency to the currency selected by
     * the user (aka "presentment" currency).
     * Please note that this relies on the `Shopify.currency` object exposed
     * by Shopify which is an undocumented feature and can change at any time.
     */
    if (
      typeof Shopify !== "undefined" &&
      typeof Shopify.currency !== "undefined" &&
      typeof Shopify.currency.rate !== "undefined" &&
      typeof Shopify.currency.active !== "undefined"
    ) {
      // Convert to "presentment" currency using the rate provided by Shopify
      priceInCents = priceInCents * Shopify.currency.rate * window.getCountryCoefficient()

      // Round up to the nearest whole number keeping in accordance with
      // the default rounding strategy of Shopify
      priceInCents = Math.ceil(priceInCents)

      function getRoundingRule(currency) {
        let hundreds = [
          "CRC",
          "AFN",
          "ALL",
          "AMD",
          "AOA",
          "BDT",
          "XOF",
          "XOF",
          "XAF",
          "XAF",
          "XOF",
          "CLP",
          "XAF",
          "CVE",
          "DJF",
          "DOP",
          "DZD",
          "XOF",
          "XAF",
          "XOF",
          "GYD",
          "HTG",
          "HUF",
          "INR",
          "ISK",
          "JMD",
          "JPY",
          "KES",
          "KGS",
          "KMF",
          "KZT",
          "LKR",
          "LRD",
          "MKD",
          "XOF",
          "MWK",
          "MZN",
          "XPF",
          "XOF",
          "NGN",
          "NPR",
          "XPF",
          "PHP",
          "PKR",
          "RSD",
          "RUB",
          "RWF",
          "XOF",
          "XAF",
          "XOF",
          "VUV",
          "XPF",
          "YER"
        ]
        let thousands = ["BIF", "CDF", "COP", "GNF", "IDR", "KHR", "KRW", "LAK", "LBP", "MMK", "MNT", "PYG", "SLL", "STD", "TZS", "UGX", "UZS", "VND"]

        if (hundreds.includes(currency)) {
          return "hundreds"
        } else if (thousands.includes(currency)) {
          return "thousands"
        } else {
          return false
        }
      }
      /**
       * Shopify uses different rounding strategies for different currencies.
       * The logic below might need to be customised based on the active currencies.
       * Note: Please only include currencies other than your store currency.
       */
      // Round up to the 95th cent for EUR
      if (Shopify.currency.active === "EUR") {
        priceInCents = parseInt(priceInCents / 100, 10) * 100 + 95
      }
      // Round up to the 00th cent for GBP, USD, DKK
      else if (!getRoundingRule(Shopify.currency.active) && Shopify.currency.active != "EUR") {
        // this was returning prices a dollar higher than they should be for the United States but correct for every other country using USD.
        // in the above else if, we're checking to be sure that the list of countries doesn't have a 100s or 1000's rounding rule.
        // since Euros is handled differently, we make sure that we exclude that as well. All countries in this condition, other than the US, get rounded up a dollar.
        if (Shopify.country != "US") {
          priceInCents = parseInt(priceInCents / 100, 10) * 100 + 100
        }
      } else if (getRoundingRule(Shopify.currency.active)) {
        // there are certain currencies that round to the nearest 100th dollar or nearest 1000th dollar, they are
        // contained in arrays above.
        if (getRoundingRule(Shopify.currency.active) == "hundreds") {
          //conversion for rounding to the nearest 100th dollar. For 100 roudning argument.
          let priceInDollars = priceInCents / 100
          priceInCents = Math.ceil(priceInDollars / 100) * 100 * 100
        } else if (getRoundingRule(Shopify.currency.active) == "thousands") {
          // conversion for rounding to the nearest 1000th dollar. For 1000 rounding argument
          let priceInDollars = priceInCents / 100
          priceInCents = Math.ceil(priceInDollars / 1000) * 1000 * 100
        }
      }
    }

    var val = (priceInCents / 100.0).toLocaleString("en", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })

    var format = algolia.money_format

    // Not necessary, but allows for more risk tolerance if Shopify.formatMoney doesn't work as we want
    var regexp = /^([^{}]*)\{\{amount\}\}([^{}]*)$/
    if (format.match(regexp)) {
      return format.replace(regexp, "$1" + val + "$2")
    }

    regexp = /^([^{}]*)\{\{amount_with_comma_separator\}\}([^{}]*)$/
    if (format.match(regexp)) {
      var money = val.replace(/[.]/, "|")
      money = money.replace(/[,]/, ".")
      money = money.replace(/[|]/, ",")
      return format.replace(regexp, "$1" + money + "$2")
    }

    if (window.Shopify && window.Shopify.formatMoney) {
      return window.Shopify.formatMoney(priceInCents, format)
    }

    return "$" + val
  }

  // algolia_init.js.liquid ================================================================>

  // algolia_analytics.js.liquid ================================================================>

  const insightsClient = algolia.externals.insightsClient
  const createAlgoliaInsightsPlugin = algolia.externals.createAlgoliaInsightsPlugin
  const createInsightsMiddleware = algolia.externals.createInsightsMiddleware
  algolia.userTokenCheck = false

  const enabled = algolia.config.analytics_enabled
  if (!enabled) return

  // useCookie parameter set up
  const userTokenAdminSetting = true
  // Generate a random alpha-numeric string that's 20 characters long
  const randomUserToken = Array.from(Array(20), () => Math.floor(Math.random() * 36).toString(36)).join("")

  if (userTokenAdminSetting) {
    window.Shopify.loadFeatures(
      [
        {
          name: "consent-tracking-api",
          version: "0.1"
        }
      ],
      (error) => {
        if (error) {
          console.error("Customer Privacy API Error", error)
        }
        const userCanBeTracked = window.Shopify.customerPrivacy ? window.Shopify.customerPrivacy.userCanBeTracked() : false
        const useCookie = userTokenAdminSetting && userCanBeTracked
        insightsClient("init", { appId: algolia.config.app_id, apiKey: algolia.config.search_api_key, useCookie })
        if (window.customer_id !== undefined) insightsClient("setUserToken", window.customer_id.toString())
        !userCanBeTracked && insightsClient("setUserToken", randomUserToken)
        algolia.userTokenCheck = true
      }
    )
  } else {
    insightsClient("init", { appId: algolia.config.app_id, apiKey: algolia.config.search_api_key })
  }

  // Autocomplete insight initialization
  algolia.algoliaInsightsPlugin = createAlgoliaInsightsPlugin({ insightsClient })
  // IS insight initialization
  algolia.insightsMiddleware = createInsightsMiddleware({ insightsClient })

  // Local storage logic for conversion events
  const localStorageKey = "algolia_analytics_clicked_objects"

  /**
   * Saves details in local storage for conversion tracking
   */
  algolia.saveForConversionTracking = function (data) {
    /**
     * We're using a try, catch here to handle any possible exceptions
     * resulting from local storage or JSON parsing.
     */
    try {
      // Get any data previously stored
      const previousClickItemsString = localStorage.getItem(localStorageKey) || "[]"
      const previousClickItems = JSON.parse(previousClickItemsString)

      var conversionData = data

      if (conversionData.eventName === "click") {
        // Changing the event to 'Added to cart' from 'click' -- Leaving this in here commented out in case we need to revert. The customer event pixel will handle this from now on.
        // conversionData.eventName = "Added to cart"
        // Removing the `positions` property if the event comes from IS
        delete conversionData.positions
      }

      // Add the current products data to local storage
      previousClickItems.push(conversionData)
      localStorage.setItem(localStorageKey, JSON.stringify(previousClickItems))
    } catch (error) {
      // No need to do anything in this scenario
    }
  }

  /**
   * Try to get the details from local storage for conversion tracking.
   * We're using a try...catch here to handle any possible exceptions resulting
   * from local storage or JSON parsing.
   */
  function trackConversion() {
    //Retrieving userToken
    let userToken
    insightsClient("getUserToken", null, (err, newUserToken) => {
      if (err) {
        console.error(err)
        return
      }
      userToken = newUserToken
    })

    try {
      // Get any previously stored data.
      const previousClickItemsString = localStorage.getItem(localStorageKey)
      // If data was found, send a conversion event for those products.
      if (!!previousClickItemsString) {
        const previousClickItems = JSON.parse(previousClickItemsString)
        previousClickItems.forEach((data) => {
          data = { ...data, userToken }
          insightsClient("convertedObjectIDsAfterSearch", data)
        })
      }
    } catch (error) {
      // No need to do anything in this scenario.
    }

    // Try to remove the items from local storage.
    try {
      localStorage.removeItem(localStorageKey)
    } catch (error) {
      // No need to do anything in this scenario.
    }
  }

  /**
   *Track a conversion event when clicking the 'add to cart' button.
   *Change the query selector to be the correct one for your theme.
   */
  const addToCartBtn = document.querySelector("[data-add-to-cart-button]")
  if (addToCartBtn) {
    addToCartBtn.addEventListener("click", function (e) {
      trackConversion()
    })
  }

  // algolia_analytics.js.liquid ================================================================>

  // algolia_translations.js.liquid ================================================================>

  algolia.translations = {
    searchTitle: "Search results for",
    search: "Current search",
    search_placeholder_mobile: "What can we help you find?",
    clear_search_mobile: "Clear",
    allProducts: "See all products ",
    matching: "matching",
    sortBy: "Sort by :",
    relevance: "Relevance",
    outOf: "out of",
    resultsFound: "items",
    oneResultFound: "1 item",
    noResultFound: "0 results for",
    noResultSubtext: "Sorry, we couldn't find any matching results for your search. Check the spelling or use a related term instead.",
    trendingSearches: "Trending Searches",
    addToCart: "Add to cart",
    searchForProduct: "",
    selectedFilter: "Selected filters",
    clearAll: "Clear all",
    outOfStock: "Out of stock",
    products: "Products",
    collections: "Collections",
    articles: "Stories",
    pages: "Pages",
    try: "Try",
    clearFilters: "clearing the filters",
    or: "or",
    changeInput: "changing your input",
    showLess: "Show less",
    showMore: "Show more",
    sale: "sale",
    finalSale: "final sale",
    soldOut: "sold out"
  }

  algolia.translation_helpers = {
    no_result_for: function (text) {
      return 'No result for " ' + text + ' ".'
    },
    in: function (processingTimeMS) {
      return "in " + processingTimeMS / 1000 + "s"
    },

    outOf: function (page, hitsPerPage, nbHits) {
      return page * hitsPerPage + 1 + "-" + Math.min((page + 1) * hitsPerPage, nbHits) + " out of"
    },

    by: function (text) {
      if (!text) return ""
      return " by " + text
    },

    render_title: function (text, query) {
      if (text === "Products" && query) {
        return text + " for " + query
      }
      return text
    }
  }

  // algolia_translations.js.liquid ================================================================>

  // algolia_helpers.js.liquid ================================================================>

  const render = algolia.externals.render
  const html = algolia.externals.html

  var algoliasearch = algolia.externals.algoliasearch
  algolia.searchClient = algoliasearch(algolia.config.app_id, algolia.config.search_api_key)

  algolia.render = (template, container, data) => {
    return render(template(html, data), container)
  }

  var algoliasearch = algolia.externals.algoliasearch
  algolia.searchClient = algoliasearch(algolia.config.app_id, algolia.config.search_api_key)

  var formatPrice = function formatPrice(value) {
    return algolia.formatMoney(Number(value) * 100)
  }

  var escapeHtml = function escapeHtml(unsafe) {
    return (unsafe || "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;")
  }

  algolia.helpers = {
    renderRefinementLabel: function renderRefinementLabel(refinement) {
      if (refinement.label.includes("#")) return refinement.label.split("||")[1]
      else if (refinement.attribute === "price_range")
        return formatPrice(refinement.label.split(":")[0]) + " - " + formatPrice(refinement.label.split(":")[1])
      else return refinement.label
    },
    isTabletUp: function isTabletUp() {
      return window.innerWidth > 480 ? true : false
    },
    minimizeFilters: function minimizeFilters() {
      document.querySelectorAll(".ais-dropdown-checkbox").forEach((e) => {
        e.checked = true
      })
    },
    expandFilters: function expandFilters() {
      document.querySelectorAll(".ais-dropdown-checkbox").forEach((e) => {
        e.checked = false
      })
    },
    formatNumber: function formatNumber(val) {
      return Number(val).toLocaleString()
    },
    displayPrice: function displayPrice(item, distinct) {
      if (distinct) {
        var min = item.variants_min_price
        var max = item.variants_max_price
        if (min !== max) {
          return Number(item.compare_at_price) && Number(item.compare_at_price) > Number(item.price)
            ? html`
                <span class="ais-hit--price-sale">
                  <span class="ais-hit-price-wrapper"
                    >${Shopify.country == "US" ? formatPrice(min) : formatPrice(min) + " " + Shopify.currency.active}</span
                  >
                  -
                  <span class="ais-hit-price-wrapper"
                    >${Shopify.country == "US" ? formatPrice(max) : formatPrice(max) + " " + Shopify.currency.active}</span
                  >
                </span>
              `
            : Shopify.country == "US"
            ? formatPrice(min) + " - " + formatPrice(max)
            : formatPrice(min) + " " + Shopify.currency.active + " - " + formatPrice(max) + " " + Shopify.currency.active
        }
      }
      return Number(item.compare_at_price) && Number(item.compare_at_price) > Number(item.price)
        ? html`
            <div class="ais-hit--price-container">
              <span class="ais-hit--price-sale">
                <span class="ais-hit-price-wrapper"
                  >${Shopify.country == "US" ? formatPrice(item.price) : formatPrice(item.price) + " " + Shopify.currency.active}</span
                >
              </span>
              <div class="ais-hit--price-striked">
                <del>
                  <span class="ais-hit-price-wrapper"
                    >${Shopify.country == "US"
                      ? formatPrice(item.compare_at_price)
                      : formatPrice(item.compare_at_price) + " " + Shopify.currency.active}</span
                  >
                </del>
              </div>
            </div>
          `
        : Shopify.country == "US"
        ? formatPrice(item.price)
        : formatPrice(item.price) + " " + Shopify.currency.active
    },

    displayStrikedPrice: function displayStrikedPrice(price, compare_at_price) {
      const comparing = Number(compare_at_price) && Number(compare_at_price) > Number(price)
      if (comparing) {
        if (Shopify.country == "US") {
          return formatPrice(compare_at_price)
        } else {
          return formatPrice(compare_at_price) + " " + Shopify.currency.active
        }
      }
    },
    displayDiscount: function displayDiscount(price, compare_at_price, price_ratio) {
      const comparing = Number(compare_at_price) && Number(compare_at_price) > Number(price)
      const discount_ratio = 1.0 - price_ratio
      if (comparing) {
        return `- ${Math.floor(discount_ratio * 100)} %`
      }
    },
    getColorName: function getColorName(hit) {
      const tags = hit.tags.filter((tag) => tag.includes("ColorName-"))
      if (tags.length > 0) {
        return tags[0].split("-")[1]
      }
    },
    displayColorVariants: function displayColorVariants(hit) {
      const product_color_name = algolia.helpers.getColorName(hit)
      const tags = hit.tags.filter((tag) => tag.includes("Style-"))
      if (tags.length > 0) {
        const styleCode = tags[0].split("-")[1]
        return html`<color-variants
          data-color-variants
          data-style="${styleCode}"
          data-current-color="${product_color_name}"
          class="color-variants__wrapper"
        >
          <div class="color-variants__product-card__colors-count typo__subheading ag-dark-mid mb12"></div>
          <div class="color-variants__swatch-container" data-swatch-container></div>
        </color-variants>`
      }
    },
    instantsearchLink: function instantsearchLink(hit) {
      const addVariantId = !hit._distinct && hit.objectID !== hit.id
      return "/products/" + hit.handle + (addVariantId ? "?variant=" + hit.objectID : "")
    },
    blogSubheadLabel: function blogSubheadLabel(hit) {
      if (Object.keys(hit.meta).length !== 0) {
        return hit.meta.custom.subhead_label
      }
    },
    getProductMainVideoUrl: function getProductMainVideoUrl(hit) {
      if (hit.meta.custom !== undefined) {
        return hit.meta.custom.product_video_hls_link
      }
    },
    fullTitle: function fullTitle(title, distinct, variant_title) {
      var res = title
      if (!distinct && variant_title && variant_title !== "Default Title" && variant_title !== "Default") {
        res += " (" + variant_title + ")"
      }

      return escapeHtml(res)
    },
    variantTitleAddition: function variantTitleAddition(item, distinct) {
      var res = " "
      if (!distinct && item.variant_title && item.variant_title !== "Default Title" && item.variant_title !== "Default") {
        res += `( ${item.variant_title} )`
      }
      return res
    },
    hexToRGB: function hexToRGB(hex) {
      if (!hex) return ``
      if (hex.length == 4) {
        hex = hex.substring(1).replace(/./g, "$&$&")
      }
      var m = hex.match(/^#?([\da-f]{2})([\da-f]{2})([\da-f]{2})$/i)
      return `${parseInt(m[1], 16)},${parseInt(m[2], 16)},${parseInt(m[3], 16)}`
    },
    sizedImage: function sizedImage(sizeInput, item, _distinct, width = true) {
      let type = width ? "width" : "height"
      var image = _distinct ? item.product_image : item.image
      if (!image) {
        return "http://cdn.shopify.com/s/images/admin/no-image-compact.gif"
      }
      var size = sizeInput.replace(/^\s+|\s+$/g, "") // Render and trim
      if (size === "original") {
        return image
      }
      return `${image}&width=${size}`
    },
    imageSrcSet: function imageSrcSet(item, _distinct, width = true) {
      let type = "w"

      const srcSet = []
      const sizes = [`250`, `500`, `960`, `1450`, `1920`]
      for (const size of sizes) {
        const image = algolia.helpers.sizedImage(size, item, _distinct, width)
        srcSet.push(`${image} ${size}${type}`)
      }
      return srcSet.join(", ")
    }
  }
  ;["pico", "icon", "thumb", "small", "compact", "medium", "large", "grande", "original"].forEach(function (size) {
    algolia.helpers[size + "Image"] = function (item) {
      var image = item.distinct ? item.product_image : item.image

      if (!image) {
        return "http://cdn.shopify.com/s/images/admin/no-image-compact.gif"
      }

      if (size === "original") {
        return image
      }
      return image.replace(/\/(.*)\.(\w{2,4})/g, `/$1_${size}.$2`)
    }
  })

  // algolia_helpers.js.liquid ================================================================>

  // algolia_autocomplete_suggestions_plugin.js.liquid ================================================================>

  const createQuerySuggestionsPlugin = algolia.externals.createQuerySuggestionsPlugin
  const { config, suggestionsTemplate } = algolia

  // Necessary exposure of config to local storage for Shopify Web Pixel in the customer events
  config.index_name = config.index_prefix + "products"
  localStorage.setItem("algolia_config", JSON.stringify(config))
  // End necessary exposure of config to local storage for Shopify Web Pixel in the customer events

  algolia.querySuggestionsPlugin = createQuerySuggestionsPlugin({
    searchClient: algolia.searchClient,
    indexName: config.query_suggestions_index_name,
    getSearchParams() {
      return {
        hitsPerPage: config.suggestions_autocomplete_hits_per_page
      }
    },
    transformSource({ source }) {
      return {
        ...source,
        getItemUrl({ item }) {
          return `/search?q=${item.query}`
        },
        templates: {
          ...source.templates,
          item(params) {
            const { item, html, components } = params
            return suggestionsTemplate({ item, html, components })
          }
        }
      }
    }
  })

  // algolia_autocomplete_suggestions_plugin.js.liquid ================================================================>

  // algolia_autocomplete_product_plugin.js.liquid ================================================================>

  const getAlgoliaResults = algolia.externals.getAlgoliaResults
  const { translations, headerTemplate, productTemplate, footerTemplate } = algolia

  // Filters for stock policy
  let stockPolicyFilter = ""

  if (algolia.config.stock_policy === "deny") {
    // For 'deny' we will filter out all items based on inventory quantity
    if (algolia.config.locations_inventory_enabled === true) {
      // if location based inventory is used, pull the online store specific inventory
      stockPolicyFilter = "locations_inventory.86459941161 > 0"
    } else {
      stockPolicyFilter = "inventory_quantity > 0"
    }
  } else if (algolia.config.stock_policy === "continue") {
    /**
     * For 'continue' we will filter on `inventory_available` attribute whose
     * value is dependent on:
     * `inventory_quantity > 0 OR inventory_policy == 'continue'`
     */
    stockPolicyFilter = "inventory_available:true"
  }

  algolia.productsPlugin = {
    getSources({ query, setContext }) {
      return [
        {
          sourceId: "products",
          getItems() {
            return getAlgoliaResults({
              searchClient: algolia.searchClient,
              queries: [
                {
                  indexName: config.index_prefix + "products",
                  query,
                  params: {
                    hitsPerPage: config.products_autocomplete_hits_per_page,
                    clickAnalytics: config.analytics_enabled,
                    filters: stockPolicyFilter,
                    distinct: algolia.config.show_products
                  }
                }
              ],
              transformResponse({ results, hits }) {
                setContext({
                  nbProducts: results[0].nbHits
                })
                return hits
              }
            })
          },
          templates: {
            header({ html, state }) {
              const resource = translations.products
              return headerTemplate({ html, state }, resource)
            },
            item({ item, html, components, state }) {
              const distinct = config.show_products
              const variantInfo = !distinct && item.objectID !== item.id ? `?variant= ${item.objectID}` : ""
              const itemLink = `/products/${item.handle}/${variantInfo}`
              const getConversionData = (e, item) => {
                if (!algolia.config.analytics_enabled) return
                algolia.saveForConversionTracking({
                  eventName: "Added to cart",
                  index: item.__autocomplete_indexName,
                  objectIDs: [item.objectID],
                  queryID: item.__autocomplete_queryID
                })
              }
              return productTemplate({ item, html, components, state }, distinct, itemLink, getConversionData)
            },
            footer({ state, html }) {
              const { autocomplete_see_all, products_autocomplete_hits_per_page } = config
              const showFooter = autocomplete_see_all && state.context.nbProducts > products_autocomplete_hits_per_page
              return showFooter && footerTemplate({ html, state })
            }
          }
        }
      ]
    }
  }

  // algolia_autocomplete_product_plugin.js.liquid ================================================================>

  // algolia_autocomplete_collections_plugin.js.liquid ================================================================>

  const { collectionsTemplate } = algolia

  algolia.collectionsPlugin = {
    getSources({ query }) {
      return [
        {
          sourceId: "collections",
          getItems() {
            return getAlgoliaResults({
              searchClient: algolia.searchClient,
              queries: [
                {
                  indexName: config.index_prefix + "collections",
                  query,
                  params: {
                    hitsPerPage: config.collections_autocomplete_hits_per_page,
                    clickAnalytics: config.analytics_enabled
                  }
                }
              ]
            })
          },
          templates: {
            header({ html, state }) {
              const resource = translations.collections
              return headerTemplate({ html, state }, resource)
            },
            item({ item, html, components }) {
              const itemLink = `/collections/${item.handle}`
              return collectionsTemplate({ item, html, components }, itemLink)
            }
          }
        }
      ]
    }
  }

  // algolia_autocomplete_collections_plugin.js.liquid ================================================================>

  // algolia_autocomplete_articles_plugin.js.liquid ================================================================>

  const { articlesTemplate } = algolia

  algolia.articlesPlugin = {
    getSources({ query, setContext }) {
      return [
        {
          sourceId: "articles",
          getItems() {
            return getAlgoliaResults({
              searchClient: algolia.searchClient,
              queries: [
                {
                  indexName: config.index_prefix + "articles",
                  query,
                  params: {
                    hitsPerPage: config.articles_autocomplete_hits_per_page,
                    clickAnalytics: config.analytics_enabled
                  }
                }
              ],
              transformResponse({ results, hits }) {
                setContext({
                  nbArticles: results[0].nbHits,
                  query: query
                })
                return hits
              }
            })
          },
          templates: {
            header({ html, state }) {
              const resource = translations.articles
              return headerTemplate({ html, state }, resource)
            },
            item({ item, html, components }) {
              const itemLink = `/blogs/${item.blog.handle}/${item.handle}`
              return articlesTemplate({ item, html, components }, itemLink)
            },
            footer({ state, html }) {
              const { autocomplete_see_all, articles_autocomplete_hits_per_page } = config
              const showFooter = autocomplete_see_all && state.context.nbArticles > articles_autocomplete_hits_per_page
              return showFooter && footerTemplate({ html, state }, true)
            }
          }
        }
      ]
    }
  }

  // algolia_autocomplete_articles_plugin.js.liquid ================================================================>

  // algolia_autocomplete_pages_plugin.js.liquid ================================================================>

  const { pagesTemplate } = algolia

  algolia.pagesPlugin = {
    getSources({ query }) {
      return [
        {
          sourceId: "pages",
          getItems() {
            return getAlgoliaResults({
              searchClient: algolia.searchClient,
              queries: [
                {
                  indexName: config.index_prefix + "pages",
                  query,
                  params: {
                    hitsPerPage: config.pages_autocomplete_hits_per_page,
                    clickAnalytics: config.analytics_enabled
                  }
                }
              ]
            })
          },
          templates: {
            header({ html, state }) {
              const resource = translations.pages
              return headerTemplate({ html, state }, resource)
            },
            item({ item, html, components }) {
              const itemLink = `/pages/${item.handle}`
              return pagesTemplate({ item, html, components }, itemLink)
            }
          }
        }
      ]
    }
  }

  // algolia_autocomplete_pages_plugin.js.liquid ================================================================>

  // algolia_autocomplete.js.liquid ================================================================>

  if (algolia.config.autocomplete_enabled) {
    const autocomplete = algolia.externals.autocomplete
    const redirectUrlPlugin = algolia.externals.createRedirectUrlPlugin()

    algolia.searchClient.addAlgoliaAgent("Shopify Integration")

    // Retrieve the container from Shopify's config
    const container = document.querySelector(algolia.config.input_selector)
    if (!container) return // No container found, abort
    container.innerHTML = ""
    const containerClasses = container.classList
    containerClasses.add("aa-MainContainer")

    // Set plugins
    const { productsPlugin, collectionsPlugin, articlesPlugin, pagesPlugin, querySuggestionsPlugin, algoliaInsightsPlugin } = algolia
    const plugins = [
      algolia.config.analytics_enabled && algoliaInsightsPlugin,
      algolia.config.index_products && productsPlugin,
      algolia.config.index_collections && collectionsPlugin,
      algolia.config.index_articles && articlesPlugin,
      algolia.config.index_pages && pagesPlugin,
      algolia.config.autocomplete_query_suggestions && querySuggestionsPlugin,
      redirectUrlPlugin
    ]

    const cssFile = document.getElementById("template_algolia_autocomplete.css")
    //Set CSS variables
    document.documentElement.style.setProperty(`--aa-text-color-rgb`, `${algolia.helpers.hexToRGB(algolia.config.colors.secondary)}`)
    document.documentElement.style.setProperty(`--aa-primary-color-rgb`, `${algolia.helpers.hexToRGB(algolia.config.colors.main)}`)
    document.documentElement.style.setProperty(`--aa-muted-color-rgb`, `${algolia.helpers.hexToRGB(algolia.config.colors.muted)}`)
    document.documentElement.style.setProperty(`--aa-highlight-color-rgb`, `${algolia.helpers.hexToRGB(algolia.config.colors.highlight)}`)
    //Link CSS
    algolia.appendStyle(cssFile.text)

    autocomplete({
      container,
      openOnFocus: true,
      debug: algolia.config.autocomplete_debug,
      plugins,
      render({ elements, render, html, state }, root) {
        const sourceIdsToExclude = ["products"]
        const hasLeftPanelResults =
          state.collections
            .filter(({ source }) => sourceIdsToExclude.indexOf(source.sourceId) === -1)
            .reduce((prev, curr) => prev + curr.items.length, 0) > 0
        const [querySuggestionsPluginResults] = state.collections.filter(({ source }) => source.sourceId === "querySuggestionsPlugin")
        const [redirectUrlPluginResults] = state.collections.filter(({ source }) => source.sourceId === "redirectUrlPlugin")
        let displaySuggestions = algolia.config.autocomplete_query_suggestions && querySuggestionsPluginResults.items.length > 0
        if (redirectUrlPluginResults.items.length > 0) displaySuggestions = true
        const hideArticles = state.query === ""
        render(
          hasLeftPanelResults
            ? algolia.mainTemplate({ html, state }, elements, displaySuggestions, !hideArticles)
            : algolia.mainProductsTemplate({ html, state }, elements),
          root
        )
      },
      renderNoResults({ render, html, state }, root) {
        render(algolia.noResultsTemplate({ html, state }), root)
      },
      onSubmit({ state }) {
        window.location.href = `/search?q=${encodeURIComponent(state.query)}`
      }
    })
  }

  // algolia_autocomplete.js.liquid ================================================================>

  // algolia_facets.js.liquid ================================================================>

  var rangeSlider = algolia.externals.widgets.rangeSlider
  var menu = algolia.externals.widgets.menu
  var refinementList = algolia.externals.widgets.refinementList

  var TYPES_TO_WIDGET = {
    slider: { name: "rangeSlider", useDefault: true, widget: rangeSlider },
    menu: { name: "menu", params: { limit: 10, searchable: false }, widget: menu },
    conjunctive: {
      name: "refinementList",
      params: { operator: "or", limit: 20, searchable: false },
      widget: refinementList
    },
    disjunctive: {
      name: "refinementList",
      params: { operator: "or", limit: 20, searchable: false },
      widget: refinementList
    }
  }

  var sortByRefined = function sortByRefined(sortFunction) {
    return function (a, b) {
      if (a.refined !== b.refined) {
        if (a.refined) {
          return -1
        }
        if (b.refined) {
          return 1
        }
      }
      return sortFunction(a, b)
    }
  }

  /*
   * Sorting functions : Allows to chose in which order you want to display the facets
   * Algolia will always send you back the most relevant values for each facet (the ones
   * with the highest count). These sorting functions won't change which results come back
   * but how they are displayed. To retrieve more results, change the maxValuesPerFacet
   * parameter in your Algolia Dashboard.
   * The default sort function is refined > count > name.
   */
  algolia.facetSortFunctions = {
    // ensure options are re-ordered upon selection
    "named_tags.Yotpo Group": sortByRefined(function sortRanges(a, b) {
      return a.name.localeCompare(b.name)
    }),
    "named_tags.Featured": sortByRefined(function sortRanges(a, b) {
      return a.name.localeCompare(b.name)
    }),
    "named_tags.Capsule": sortByRefined(function sortRanges(a, b) {
      return a.name.localeCompare(b.name)
    }),
    "named_tags.Detail": sortByRefined(function sortRanges(a, b) {
      return a.name.localeCompare(b.name)
    }),
    "named_tags.Hem": sortByRefined(function sortRanges(a, b) {
      return a.name.localeCompare(b.name)
    }),
    "named_tags.AG-ed": sortByRefined(function sortRanges(a, b) {
      return a.name.localeCompare(b.name)
    }),
    "named_tags.Sub Category": sortByRefined(function sortRanges(a, b) {
      return a.name.localeCompare(b.name)
    }),
    "named_tags.Sleeve": sortByRefined(function sortRanges(a, b) {
      return a.name.localeCompare(b.name)
    }),
    "named_tags.Stretch": sortByRefined(function sortRanges(a, b) {
      return a.name.localeCompare(b.name)
    }),
    "named_tags.Sub Title": sortByRefined(function sortRanges(a, b) {
      return a.name.localeCompare(b.name)
    }),
    "named_tags.Yotpo Tag": sortByRefined(function sortRanges(a, b) {
      return a.name.localeCompare(b.name)
    }),
    "named_tags.Color Code": sortByRefined(function sortRanges(a, b) {
      return a.name.localeCompare(b.name)
    }),
    "named_tags.Division": sortByRefined(function sortRanges(a, b) {
      return a.name.localeCompare(b.name)
    }),
    "named_tags.Fabric": sortByRefined(function sortRanges(a, b) {
      return a.name.localeCompare(b.name)
    }),
    "named_tags.Product": sortByRefined(function sortRanges(a, b) {
      return a.name.localeCompare(b.name)
    }),
    "named_tags.Season Code": sortByRefined(function sortRanges(a, b) {
      return a.name.localeCompare(b.name)
    }),
    "named_tags.Season": sortByRefined(function sortRanges(a, b) {
      return a.name.localeCompare(b.name)
    }),
    "named_tags.Color Name": sortByRefined(function sortRanges(a, b) {
      return a.name.localeCompare(b.name)
    }),
    "named_tags.StyleCode": sortByRefined(function sortRanges(a, b) {
      return a.name.localeCompare(b.name)
    }),
    "named_tags.Wash": sortByRefined(function sortRanges(a, b) {
      return a.name.localeCompare(b.name)
    }),
    "named_tags.Final Sale": sortByRefined(function sortRanges(a, b) {
      return a.name.localeCompare(b.name)
    }),
    "named_tags.Category": sortByRefined(function sortRanges(a, b) {
      return a.name.localeCompare(b.name)
    }),
    "named_tags.Closure": sortByRefined(function sortRanges(a, b) {
      return a.name.localeCompare(b.name)
    }),
    "named_tags.Color": sortByRefined(function sortRanges(a, b) {
      return a.name.localeCompare(b.name)
    }),
    "named_tags.Fit": sortByRefined(function sortRanges(a, b) {
      return a.name.localeCompare(b.name)
    }),
    "named_tags.Gender": sortByRefined(function sortRanges(a, b) {
      return a.name.localeCompare(b.name)
    }),
    "named_tags.Length": sortByRefined(function sortRanges(a, b) {
      return a.name.localeCompare(b.name)
    }),
    "named_tags.Material": sortByRefined(function sortRanges(a, b) {
      return a.name.localeCompare(b.name)
    }),
    "named_tags.Rise": sortByRefined(function sortRanges(a, b) {
      return a.name.localeCompare(b.name)
    }),
    "named_tags.color": sortByRefined(function sortRanges(a, b) {
      return a.name.localeCompare(b.name)
    }),
    "named_tags.fit": sortByRefined(function sortRanges(a, b) {
      return a.name.localeCompare(b.name)
    }),
    "named_tags.rise": sortByRefined(function sortRanges(a, b) {
      return a.name.localeCompare(b.name)
    }),
    "named_tags.style": sortByRefined(function sortRanges(a, b) {
      return a.name.localeCompare(b.name)
    }),
    "options.color": sortByRefined(function sortRanges(a, b) {
      return a.name.localeCompare(b.name)
    }),
    "options.title": sortByRefined(function sortRanges(a, b) {
      return a.name.localeCompare(b.name)
    }),
    "options.inseam": sortByRefined(function sortRanges(a, b) {
      return a.name.localeCompare(b.name)
    }),
    price_range: sortByRefined(function sortRanges(a, b) {
      if (a.name.length === b.name.length) {
        return a.name.localeCompare(b.name)
      }
      return a.name.length - b.name.length
    })
  }

  /*
   * Display functions
   * When the object sent back for a facet item doesn't match how you would want it to look
   * like, use a function to reformat it how you want.
   */
  algolia.facetDisplayFunctions = {
    price_range: function displayRange(value) {
      var values = value.split(":")

      return values
        .map((e) => {
          return algolia.formatMoney(Number(e) * 100).replace(/\.\d+/, "")
        })
        .join(" - ")
    }
  }

  algolia.facetCssClasses = {
    root: "ais-facet",
    header: "ais-facet--header",
    body: "ais-facet--body",
    item: "ais-facet--item",
    label: "ais-facet--label",
    checkbox: "ais-facet--checkbox",
    active: "ais-facet--active",
    count: Boolean(algolia.config.show_products) ? "ais-facet--count-distinct" : "ais-facet--count"
  }

  var enabledFacets = algolia.config.facets.filter((facet) => {
    return facet.enabled || parseInt(facet.enabled, 10)
  })
  algolia.facets = enabledFacets.map((facet) => ({
    ...facet,
    escapedName: encodeURIComponent(facet.name)
  }))
  algolia.shownFacets = algolia.facets.filter((facet) => {
    return facet.type !== "hidden"
  })
  algolia.hiddenFacets = algolia.config.facets.filter((facet) => {
    return facet.type === "hidden"
  })

  var facetToWidget = function (facet) {
    var widget = TYPES_TO_WIDGET[facet.type]
    var params = algolia.assign({}, widget.params)

    params.container = "[class~='ais-facet-" + facet.escapedName + "-container']"
    params.attribute = facet.name
    params.templates = {}
    params.cssClasses = algolia.facetCssClasses

    /**
     * Providing a custom "Show more" template to confirm to the custom
     */
    params.templates.showMoreText = function showMoreText(data, { html }) {
      return algolia.instantSearchShowMore(data, html)
    }

    if (facet.searchable) {
      params.searchable = true
      params.searchablePlaceholder = "Search for " + facet.title
      params.templates.searchableNoResults = "<div> No matching for " + facet.title + "</div>"
    }

    params.templates.header = function () {
      return facet.title
    }

    if (!widget.useDefault) {
      params.templates.item = (item, { html }) => {
        return algolia.instantSearchFacetItem(item, html)
      }
    }

    if (algolia.facetSortFunctions[facet.name]) {
      params.sortBy = algolia.facetSortFunctions[facet.name]
    }

    var displayFunction = algolia.facetDisplayFunctions[facet.name]
    params.transformItems = function (items) {
      return items.map((item) => ({
        ...item,
        type: facet.type,
        label: displayFunction ? displayFunction(item.value) : item.value
      }))
    }

    return {
      name: widget.name,
      params: params,
      widget: widget.widget
    }
  }

  // try to fetch facets for current collection or fallback to collections default
  var collection_facets =
    algolia.current_collection_id && algolia.config.collection_facets && algolia.config.collection_facets[algolia.current_collection_id]
      ? algolia.config.collection_facets[algolia.current_collection_id]
      : algolia.config.collection_facets && algolia.config.collection_facets.default

  if (collection_facets) {
    var enabledCollectionFacets = collection_facets.filter((facet) => {
      return facet.enabled || parseInt(facet.enabled, 10)
    })

    algolia.collectionFacets = enabledCollectionFacets.map((facet) => ({
      ...facet,
      escapedName: encodeURIComponent(facet.name)
    }))
    algolia.collectionShownFacets = algolia.collectionFacets.filter((facet) => {
      return facet.type !== "hidden"
    })
    algolia.collectionHiddenFacets = collection_facets.filter((facet) => {
      return facet.type === "hidden"
    })
    algolia.collectionFacetsWidgets = algolia.collectionShownFacets.map(facetToWidget)
  }
  algolia.facetsWidgets = algolia.shownFacets.map(facetToWidget)

  // algolia_facets.js.liquid ================================================================>

  // algolia_sort_orders.js.liquid ================================================================>

  var sort_order_base = algolia.config.index_prefix + "products"
  algolia.sortOrders = [{ value: sort_order_base, label: "" + algolia.translations.relevance }]

  algolia.config.sort_orders.forEach(function (sort_order) {
    if (sort_order.asc && (sort_order.asc.active === true || sort_order.asc.active === "1")) {
      algolia.sortOrders.push({
        value: sort_order_base + "_" + sort_order.key + "_asc",
        label: sort_order.asc.title
      })
    }

    if (sort_order.desc && (sort_order.desc.active === true || sort_order.desc.active === "1")) {
      algolia.sortOrders.push({
        value: sort_order_base + "_" + sort_order.key + "_desc",
        label: sort_order.desc.title
      })
    }
  })

  // try to fetch sort orders for current collection or fallback to collections default
  var collection_sort_orders =
    algolia.current_collection_id && algolia.config.collection_sort_orders && algolia.config.collection_sort_orders[algolia.current_collection_id]
      ? algolia.config.collection_sort_orders[algolia.current_collection_id]
      : algolia.config.collection_sort_orders && algolia.config.collection_sort_orders.default

  if (collection_sort_orders) {
    algolia.collectionSortOrders = [{ value: sort_order_base, label: "" + algolia.translations.relevance }]

    collection_sort_orders.forEach(function (sort_order) {
      if (sort_order.asc && (sort_order.asc.active === true || sort_order.asc.active === "1")) {
        algolia.collectionSortOrders.push({
          value: sort_order_base + "_" + sort_order.key + "_asc",
          label: sort_order.asc.title
        })
      }

      if (sort_order.desc && (sort_order.desc.active === true || sort_order.desc.active === "1")) {
        algolia.collectionSortOrders.push({
          value: sort_order_base + "_" + sort_order.key + "_desc",
          label: sort_order.desc.title
        })
      }
    })
  }

  // algolia_sort_orders.js.liquid ================================================================>

  // algolia_instant_search.js.liquid ================================================================>

  var instantsearch = algolia.externals.instantsearch
  var algoliasearch = algolia.externals.algoliasearch
  var searchBox = algolia.externals.widgets.searchBox
  var stats = algolia.externals.widgets.stats
  var sortBy = algolia.externals.widgets.sortBy
  var clearRefinements = algolia.externals.widgets.clearRefinements
  var panel = algolia.externals.widgets.panel
  var hits = algolia.externals.widgets.hits
  var pagination = algolia.externals.widgets.pagination
  var infiniteHits = algolia.externals.widgets.infiniteHits
  var configure = algolia.externals.widgets.configure
  var connectCurrentRefinements = algolia.externals.connectors.connectCurrentRefinements
  var connectRefinementList = algolia.externals.connectors.connectRefinementList
  var connectInfiniteHits = algolia.externals.connectors.connectInfiniteHits
  var connectSortBy = algolia.externals.connectors.connectSortBy
  let firstRender = true

  var collectionPageEnabled = algolia.is_collection_results_page && algolia.config.instant_search_enabled_on_collection

  if (!algolia.full_results && !algolia.is_collection_results_page) {
    /**
     * If we aren't on the search page and neither on a collection page,
     * then there's no need to proceed
     */
    return
  } else if (algolia.full_results) {
    /**
     * If we are on the search page and instant search isn't enabled,
     * then there's no need to proceed
     */
    if (!algolia.config.instant_search_enabled) {
      return
    }
  } else if (algolia.is_collection_results_page) {
    /**
     * If we are on a collection page and instant search on collection isn't
     * enabled, then there's no need to proceed
     */
    if (!algolia.config.instant_search_enabled_on_collection) {
      return
    }
  }

  /**
   * Array which will contain all filters to be applied while initiating the
   * search API call.
   */
  var searchFilters = []

  var collectionFacetFilter = null
  var collectionRulesContextValue = null
  var collectionHandle = null

  if (collectionPageEnabled) {
    var matches = window.location.pathname.match(/\/collections\/([^/]+)/i)
    collectionHandle = Boolean(matches) && matches.length === 2 ? matches[1] : null

    // Filter on collection handle instead
    if (algolia.config.collection_id_indexing) {
      collectionFacetFilter = collectionHandle ? 'collections:"' + collectionHandle + '"' : null
    } else {
      collectionFacetFilter = algolia.current_collection_id ? 'collection_ids:"' + algolia.current_collection_id + '"' : null
    }

    // Add the collection filter to the list of search filters
    searchFilters.push(collectionFacetFilter)

    collectionRulesContextValue = algolia.config.collection_id_query_rules ? algolia.current_collection_id : collectionHandle
  }

  // Filters for stock policy
  var stockPolicyFilter2 = null
  if (algolia.config.stock_policy) {
    if (algolia.config.stock_policy === "allow") {
      /**
       * For 'allow', we don't need to add any filter as we want to continue
       * displaying all out of stock items.
       */
    } else if (algolia.config.stock_policy === "deny") {
      // For 'deny' we will filter out all items based on inventory quantity
      if (algolia.config.locations_inventory_enabled === true) {
        // if location based inventory is used, pull the online store specific inventory
        stockPolicyFilter2 = "locations_inventory.86459941161 > 0"
      } else {
        stockPolicyFilter2 = "inventory_quantity > 0"
      }
    } else if (algolia.config.stock_policy === "continue") {
      /**
       * For 'continue' we will filter on `inventory_available` attribute whose
       * value is dependent on:
       * `inventory_quantity > 0 OR inventory_policy == 'continue'`
       */
      stockPolicyFilter2 = "inventory_available:true"
    }

    // Add the stock policy filter to the list of search filters
    if (stockPolicyFilter2) {
      searchFilters.push(stockPolicyFilter2)
    }
  }

  var results_selector = collectionPageEnabled ? algolia.config.collection_css_selector : algolia.config.results_selector

  var activeSortOrders = collectionPageEnabled && algolia.collectionSortOrders ? algolia.collectionSortOrders : algolia.sortOrders

  results_selector += ", .algolia-shopify-instantsearch"

  function getTrackedUiState(uiState) {
    var trackedUiState = {}
    Object.keys(uiState).forEach(function (k) {
      if (k === "configure" || k === "query" || k === "q") {
        return
      }
      trackedUiState[k] = uiState[k]
    })
    return trackedUiState
  }

  /**
   * List of URL params which are "allowed" by InstantSearch.
   * These parameters won't be overwritten when the search state is written
   * to the URL.
   */
  var ALLOWED_FOREIGN_PARAMS = [
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_term",
    "utm_content",
    "tab",
    "gclid",
    "gad_source",
    "gbraid",
    "fbclid",
    "utm_klaviyo_id",
    "utm_id"
  ]
  var foreignRouteState

  function singleIndex(indexName) {
    return {
      /**
       * `stateToRoute` method transforms the `uiState` object from InstantSearch
       * into an object that will then be serialized to construct the URL.
       */
      stateToRoute: function (uiState) {
        var route = getTrackedUiState(uiState[indexName] || {})
        route.q = uiState[indexName].query
        return Object.assign({}, foreignRouteState, route)
      },

      /**
       * `routeToState` method transforms the route object into a `uiState` object
       * so that InstantSearch is initialized with the correct state from the
       * URL.
       */
      routeToState: function (routeState) {
        /**
         * Backup parameters from `routeState` into a different object
         * `foreignRouteState` so that we can re-inject them into the object
         * returned within `stateToRoute`.
         * This allows us to preserve the parameters specified in `ALLOWED_FOREIGN_PARAMS`
         * array.
         */
        if (!foreignRouteState) {
          foreignRouteState = ALLOWED_FOREIGN_PARAMS.reduce(function (acc, key) {
            acc[key] = routeState[key]
            return acc
          }, {})
        }
        var state = {}
        state[indexName] = getTrackedUiState(routeState || {})
        state[indexName].query = routeState.q
        return state
      }
    }
  }

  var instant = {
    colors: algolia.config.colors,
    distinct: Boolean(algolia.config.show_products),
    facets: {
      hidden: collectionPageEnabled && algolia.collectionHiddenFacets ? algolia.collectionHiddenFacets : algolia.hiddenFacets,
      shown: collectionPageEnabled && algolia.collectionShownFacets ? algolia.collectionShownFacets : algolia.shownFacets,
      list: collectionPageEnabled && algolia.collectionFacets ? algolia.collectionFacets : algolia.facets,
      widgets: collectionPageEnabled && algolia.collectionFacetsWidgets ? algolia.collectionFacetsWidgets : algolia.facetsWidgets
    },
    hitsPerPage:
      collectionPageEnabled && algolia.config.collections_full_results_hits_per_page
        ? algolia.config.collections_full_results_hits_per_page
        : algolia.config.products_full_results_hits_per_page,
    search: instantsearch({
      searchClient: algoliasearch(algolia.config.app_id, algolia.config.search_api_key),
      indexName: algolia.config.index_prefix + "products",
      routing: {
        stateMapping: singleIndex(algolia.config.index_prefix + "products")
      },
      searchFunction: function (searchFunctionHelper) {
        // Set query parameters here because they're not kept when someone
        // presses the Back button if set in the `init` function of a custom widget
        var page = searchFunctionHelper.getPage()
        if (instant.distinct) {
          searchFunctionHelper.setQueryParameter("distinct", true)
        }

        // Assign any required filters
        if (searchFilters.length) {
          searchFunctionHelper.setQueryParameter("filters", searchFilters.join(" AND "))
        }

        // Assign any required `ruleContexts` which are required for query rules
        // targeting collection pages

        // Collection page merchandising:
        // If we are on a collection page, `collectionRulesContextValue` is defined
        if (collectionRulesContextValue) {
          searchFunctionHelper.setQueryParameter("ruleContexts", [collectionRulesContextValue.toString(), "collection-page"])
        } else {
          searchFunctionHelper.setQueryParameter("ruleContexts", ["search-page"])
        }

        searchFunctionHelper.setPage(page)
        searchFunctionHelper.search()
      }
    }),
    selector: results_selector + ", .algolia-shopify-instantsearch",
    sortOrders: activeSortOrders
  }

  instant.search.client.addAlgoliaAgent("Shopify Integration")

  if (algolia.config.analytics_enabled) {
    // Connecting IS with the insights middleware
    instant.search.use(algolia.insightsMiddleware)
  }

  algolia.instantsearch = instant

  function readjust() {
    var width = instant.$results.offsetWidth

    var suffix = "lg"
    if (width < 400) suffix = "xs"
    else if (width < 800) suffix = "sm"
    else if (width < 1200) suffix = "md"

    instant.$results.classList.remove("ais-results-size-xs")
    instant.$results.classList.remove("ais-results-size-sm")
    instant.$results.classList.remove("ais-results-size-md")
    instant.$results.classList.remove("ais-results-size-lg")
    instant.$results.classList.add("ais-results-size-" + suffix)
  }

  if (collectionPageEnabled) {
    if (document.querySelectorAll(algolia.config.collection_css_selector).length === 0) {
      throw new Error(
        "Instant search CSS selector for collection page is incorrect\nFor more info see: https://www.algolia.com/doc/integration/shopify/advanced-customization/collection-search-page/#css-selector"
      )
    }
  } else if (document.querySelectorAll(algolia.config.results_selector).length === 0) {
    throw new Error(
      "Instant search CSS selector is incorrect\nFor more info see: https://www.algolia.com/doc/integration/shopify/building-search-ui/instant-search/#css-selector"
    )
  }

  // Instantiating the main page
  instant.$results = document.querySelector(instant.selector)
  instant.$results.innerHTML = ""

  algolia.render(algolia.instantSearchMainTemplate, instant.$results, {
    facets: instant.facets.list,
    multipleSortOrders: activeSortOrders.length > 1
  })

  readjust()

  window.addEventListener("resize", function () {
    readjust()
  })

  // Facet menu display
  instant.search.addWidgets([
    {
      init: function () {
        const $button = document.querySelector(".ais-facets-button")
        let $facetEls = document.querySelectorAll(
          ".ais-facet-dropdown-wrapper:not(.hidden) .ais-facet--header, .ais-facet-dropdown-wrapper:not(.hidden) .ais-facet-dropdown-container .ais-RefinementList-item"
        )
        algolia.helpers.minimizeFilters() // minimize filters to fix container height issue

        $button.addEventListener("click", function () {
          const $facets = document.querySelector(".ais-facets")
          const $facetsBg = document.querySelector(".ais-facets__overlay")
          $facetEls = document.querySelectorAll(
            ".ais-facet-dropdown-wrapper:not(.hidden) .ais-facet--header, .ais-facet-dropdown-wrapper:not(.hidden) .ais-facet-dropdown-container .ais-RefinementList-item"
          )

          if ($facets.classList.contains("ais-facets__shown")) {
            // CLOSE panel
            $button.textContent = "filter"
            algolia.helpers.minimizeFilters() // minimize filters to fix container height issue
            $facets.classList.remove("ais-facets__shown")
            $facetsBg.classList.remove("ais-facets__shown")
            $facetEls.forEach((e) => {
              e.removeAttribute("tabindex")
            })
            localStorage.setItem("algolia_filters_open", false)
          } else {
            // OPEN panel
            $button.textContent = "filter"
            algolia.helpers.expandFilters()
            $facets.classList.add("ais-facets__shown")
            $facetsBg.classList.add("ais-facets__shown")
            $facetEls.forEach((e) => {
              e.setAttribute("tabindex", 0)
            })
            $facetEls[0].focus()
            localStorage.setItem("algolia_filters_open", true)
            // listen for clicks on overlay and apply button on mobile and close menu if clicked
            document.querySelector(".ais-facets__overlay").addEventListener("click", function () {
              $facets.classList.remove("ais-facets__shown")
              $facetsBg.classList.remove("ais-facets__shown")
            })
            document.querySelector(".ais-facets__apply-button").addEventListener("click", function () {
              $facets.classList.remove("ais-facets__shown")
              $facetsBg.classList.remove("ais-facets__shown")
            })
          }
        })
        $button.addEventListener("keypress", (e) => {
          if (e.key === "Enter") {
            $button.click()
          }
        })
      }
    }
  ])

  instant.search.addWidgets([
    configure({
      hitsPerPage: instant.hitsPerPage,
      facetingAfterDistinct: false,
      enablePersonalization: true,
      userToken: window.customer_id
    })
  ])

  // Search input
  instant.search.addWidgets([
    searchBox({
      container: ".ais-search-box-container",
      placeholder: algolia.translations.searchForProduct,
      showReset: false,
      showSubmit: true,
      searchAsYouType: false,
      showLoadingIndicator: true,
      queryHook(query, search) {
        window.location.href = `/search?q=${encodeURIComponent(query)}`
      }
    })
  ])

  // Logo & clear
  instant.search.addWidgets([
    {
      init: function (opts) {
        document.querySelector(".ais-clear-input-icon").addEventListener("click", function () {
          opts.helper.setQuery("").search()
          var input = document.querySelector(".ais-search-box--input")
          input.value = ""
          input.focus()
        })
      },
      render: function (opts) {
        document.querySelector(".ais--search-term").innerHTML = '"' + instant.search.helper.lastResults.query + '"'
        if (!opts.state.query) {
          document.querySelector(".ais-clear-input-icon").style.display = "none"
        } else {
          document.querySelector(".ais-clear-input-icon").style.display = ""
        }
      }
    }
  ])

  // UI Modifications
  instant.search.addWidgets([
    {
      init: function () {
        // custom size filters
        const sizeFacet = document.querySelector(".ais-facet-options\\.size")
        const inseamFacet = document.querySelector(".ais-facet-options\\.inseam")
        if (inseamFacet !== null) {
          const inseamFacetContainer = inseamFacet.querySelector(".ais-facet-dropdown-container")
          sizeFacet.append(inseamFacetContainer)
          inseamFacet.remove()
        }

        // if the URL has the tab=blog param load the blog tab
        const queryParams = new URLSearchParams(window.location.search)
        if (queryParams.get("tab") === "blog") {
          document.querySelector(".ais--view .ais--view-products").classList.remove("active")
          document.querySelector(".ais--view .ais--view-blogs").classList.add("active")
          document.querySelector(".ais-blogs-container").classList.remove("hidden")
          document.querySelector(".ais-products-container").classList.add("hidden")
          const queryParams = new URLSearchParams(window.location.search)
          queryParams.set("tab", "blog")
          history.replaceState(null, null, "?" + queryParams.toString())
        }
        // switch between product or article (only on search page)
        document.querySelector(".ais--view .ais--view-products").addEventListener("click", function () {
          document.querySelector(".ais--view .ais--view-blogs").classList.remove("active")
          document.querySelector(".ais--view .ais--view-products").classList.add("active")
          document.querySelector(".ais-products-container").classList.remove("hidden")
          document.querySelector(".ais-blogs-container").classList.add("hidden")
          const queryParams = new URLSearchParams(window.location.search)
          queryParams.delete("tab")
          history.replaceState(null, null, "?" + queryParams.toString())
        })
        document.querySelector(".ais--view .ais--view-blogs").addEventListener("click", function () {
          document.querySelector(".ais--view .ais--view-products").classList.remove("active")
          document.querySelector(".ais--view .ais--view-blogs").classList.add("active")
          document.querySelector(".ais-blogs-container").classList.remove("hidden")
          document.querySelector(".ais-products-container").classList.add("hidden")
          const queryParams = new URLSearchParams(window.location.search)
          queryParams.set("tab", "blog")
          history.replaceState(null, null, "?" + queryParams.toString())
        })

        //init wishlist
        function swymCallbackFn(swat) {
          function swymAttachEvents() {
            swat.initializeActionButtons(".ais-InfiniteHits")
          }
          swymAttachEvents()
        }
        if (!window.SwymCallbacks) {
          window.SwymCallbacks = []
        }
        window.SwymCallbacks.push(swymCallbackFn)
      }
    }
  ])

  // Stats
  instant.search.addWidgets([
    stats({
      container: ".ais-stats-container",
      templates: {
        text(data, { html }) {
          return algolia.instantSearchStatsTemplate(data, html)
        }
      }
    })
  ])

  // Sort orders
  if (activeSortOrders.length > 1) {
    instant.search.addWidgets([
      sortBy({
        container: ".ais-sort-orders-container",
        items: instant.sortOrders
      })
    ])
  }

  instant.search.on("render", () => {
    if (instant.search.status === "idle") {
      document.dispatchEvent(new CustomEvent("algolia:loaded"))

      // ADA fixes for filter menu
      let $facetEls = document.querySelectorAll(
        ".ais-facet-dropdown-wrapper:not(.hidden) .ais-facet--header, .ais-facet-dropdown-wrapper:not(.hidden) .ais-facet-dropdown-container .ais-RefinementList-item"
      )
      $facetEls.forEach((el) => {
        if (!el.dataset.hasListener) {
          el.addEventListener("keydown", function (e) {
            if (e.key === "Enter") {
              this.click()
            }
          })
          el.dataset.hasListener = true
        }
      })
      if (localStorage.getItem("algolia_filters_open") !== "false") {
        $facetEls.forEach((el) => {
          el.setAttribute("tabindex", 0)
        })
      }
    }
  })

  // Hidden facets
  var list = instant.facets.hidden.map(function (facet) {
    return facet.name
  })
  instant.search.addWidgets([
    {
      getConfiguration: function () {
        return {
          facets: list,
          disjunctiveFacets: list
        }
      },
      init: function () {}
    }
  ])

  // custom refinements
  // 1. Create a render function
  const renderRefinementList = (renderOptions, isFirstRender) => {
    const { items, isFromSearch, refine, createURL, isShowingMore, canToggleShowMore, searchForItems, toggleShowMore, widgetParams } = renderOptions

    const combinedOptions = {
      XS: ["XS/S"],
      S: ["XS/S", "S/M"],
      M: ["S/M", "M/L"],
      L: ["M/L", "L/XL"],
      XL: ["L/XL", "XL/XXL"],
      XXL: ["XL/XXL"]
    }
    if (widgetParams.container.querySelector("ul") !== null) {
      widgetParams.container.querySelector("ul").innerHTML = items
        .map((item) => {
          let isCombinedOption = false
          // check if filter item is a combined option
          for (const [key, value] of Object.entries(combinedOptions)) {
            if (value.includes(item.value)) {
              isCombinedOption = true
            }
          }
          if (item.count === 0 || isCombinedOption) {
            // dont display the combined options or filter items that have no products
            return `
                  <li
                    class="hidden"
                    data-value="${item.value}"
                    data-count="${item.count}"
                    data-is-refined="${item.isRefined}"
                  ></li>
              `
          } else {
            return `
                  <li
                    class="ais-RefinementList-item-custom ais-RefinementList-item ais-facet--item${
                      item.isRefined ? " ais-RefinementList-item--selected" : ""
                    }"
                    data-value="${item.value}"
                    data-count="${item.count}"
                    data-is-refined="${item.isRefined}"
                  >
                    <div>
                      <label class="ais-RefinementList-label ais-facet--label">
                        ${item.label}
                      </label>
                    </div>
                  </li>
                `
          }
        })
        .join("")
      // setup click event listeners
      ;[...widgetParams.container.querySelectorAll("li")].forEach((element) => {
        element.addEventListener("click", (event) => {
          event.preventDefault()
          const currentTarget = event.currentTarget
          refine(currentTarget.dataset.value)
          // check combined options to see if there are additional options to refine
          if (combinedOptions.hasOwnProperty(currentTarget.dataset.value)) {
            combinedOptions[currentTarget.dataset.value].forEach((combinedOption) => {
              const combinedItem = items.find(function (f) {
                if (f.value === combinedOption) return f
              })
              if (combinedItem !== undefined && currentTarget.dataset.isRefined === "false") {
                // if we are selecting a new filter
                // only add combo options that aren't refined
                if (combinedItem.isRefined === false) refine(combinedOption)
              } else if (combinedItem !== undefined && currentTarget.dataset.isRefined === "true") {
                // if we are de-selecting a filter
                // only remove combo options that are refined
                if (combinedItem.isRefined === true) refine(combinedOption)
              }
            })
          }
        })
      })
    }
  }

  // 2. Create the custom widget
  const customRefinementList = connectRefinementList(renderRefinementList)

  // 3. Instantiate
  instant.search.addWidgets([
    customRefinementList({
      container: document.querySelector(".ais-facet-options\\.size-container"),
      attribute: "options.size",
      showMore: false,
      limit: 100
    })
  ])

  // Create the render function
  var createDataAttributes = function (refinement) {
    return Object.keys(refinement)
      .map(function (key) {
        return "data-" + key + '="' + encodeURIComponent(refinement[key] || "") + '"'
      })
      .join(" ")
  }

  var renderListItem = function (item) {
    var facet = instant.facets.list.find(function (f) {
      return f.name === item.label
    })
    return item.refinements
      .map(function (refinement) {
        return (
          '<li class="ais-current-refined-values--item">' +
          "  <a " +
          createDataAttributes(refinement) +
          '    class="ais-current-refined-values--link" tabindex="0">' +
          "    <div>" +
          '      <div class="ais-current-refined-values--label">' +
          facet.title +
          "      </div>" +
          algolia.helpers.renderRefinementLabel(refinement) +
          "    </div>" +
          "  </a>" +
          "</li>"
        )
      })
      .join("")
  }

  var renderCurrentRefinements = function (renderOptions) {
    var items = renderOptions.items
    var refine = renderOptions.refine
    var widgetParams = renderOptions.widgetParams

    widgetParams.container.innerHTML =
      '<div class="ais-current-refined-values--header ais-header">Selected filters</div>' +
      '<div class="ais-root ais-current-refined-values ais-facet">' +
      '  <ul class="ais-current-refined-values--list">' +
      items.map(renderListItem).join("") +
      "  </ul>" +
      "</div>"

    Array.prototype.slice.call(widgetParams.container.querySelectorAll(".ais-current-refined-values--link")).forEach(function (element) {
      element.addEventListener("click", function (event) {
        var item = Object.keys(event.currentTarget.dataset).reduce(function (acc, key) {
          var itemData = {}
          itemData[key] = decodeURIComponent(event.currentTarget.dataset[key])
          return algolia.assign({}, acc, itemData)
        }, {})

        refine(item)
      })
      element.addEventListener("keypress", function (e) {
        if (e.key == "Enter") this.click()
      })
    })
  }

  // Create the custom widget
  var customCurrentRefinements = connectCurrentRefinements(renderCurrentRefinements)

  var hasRefinements = function (helper, facetsList) {
    return facetsList.some(function (f) {
      var isConjunctiveFacetRefined = helper.state.isConjunctiveFacet(f.name) && helper.state.isFacetRefined(f.name)
      var isDisjunctiveFacetRefined = helper.state.isDisjunctiveFacet(f.name) && helper.state.isDisjunctiveFacetRefined(f.name)
      var isHierarchicalFacetRefined = helper.state.isHierarchicalFacet(f.name) && helper.state.isHierarchicalFacetRefined(f.name)

      var numericRefinements = helper.state.getNumericRefinements(f.name)
      var isNumericFacetRefined = Object.keys(numericRefinements).some(function (operator) {
        return numericRefinements[operator].length > 0
      })

      return isNumericFacetRefined || isConjunctiveFacetRefined || isDisjunctiveFacetRefined || isHierarchicalFacetRefined
    })
  }

  /**
   * Decides whether the given `facetName` has any facet values available in
   * the current result set by checking the available `facets`,
   * `disjunctiveFacets` and `hierarchicalFacets`.
   */
  var hasFacetValues = function (resultState, facetName) {
    var isFacetValueAvailable = resultState.facets.some(function (facet) {
      return facet.name === facetName
    })
    var isDisjunctiveFacetValueAvailable = resultState.disjunctiveFacets.some(function (facet) {
      return facet.name === facetName
    })
    var isHierarchicalFacetValueAvailable = resultState.hierarchicalFacets.some(function (facet) {
      return facet.name === facetName
    })

    return isFacetValueAvailable || isDisjunctiveFacetValueAvailable || isHierarchicalFacetValueAvailable
  }

  var customCurrentRefinementsWithPanel = panel({
    hidden: function (options) {
      return !hasRefinements(options.helper, instant.facets.list)
    }
  })(customCurrentRefinements)

  var clearRefinementsWithPanel = panel({
    hidden: function (options) {
      return !hasRefinements(options.helper, instant.facets.list)
    }
  })(clearRefinements)

  instant.search.addWidgets([
    clearRefinementsWithPanel({
      container: document.querySelector(".ais-clear-refinements-container"),
      templates: {
        resetLabel: algolia.translations.clearAll
      }
    }),
    customCurrentRefinementsWithPanel({
      container: document.querySelector(".ais-current-refined-values-container")
    })
  ])

  /**
   * Setup the facets for search.
   * We are using a `panel` with a custom `hidden` function which will allow
   * us to hide the parent container of the facet if there are no facet values
   * available for that particular facet.
   */
  instant.facets.widgets.forEach(function (widget) {
    var facetWithPanel = panel({
      hidden: function (options) {
        var hide = !hasFacetValues(options.results, widget.params.attribute)
        var displayStyle = hide ? "none" : ""

        /**
         * Replacing any "." and "%" in the class name with "\." and "\%" so that querySelector
         * can work as expected. "." is supposed to be present for named tags
         * and metafield based facet names and "%" is present when the facet name has a space
         * in it because of the encoding.
         */
        var parentContainerClassName = ".ais-facet-" + encodeURIComponent(widget.params.attribute).replace(/\./g, "\\.").replace(/\%/g, "\\%")
        var parentContainer = document.querySelector(parentContainerClassName)

        if (parentContainer) {
          parentContainer.style.display = displayStyle
        }

        return hide
      }
    })(widget.widget)

    instant.search.addWidgets([facetWithPanel(widget.params)])
  })

  // Hits
  instant.search.addWidgets([
    hits({
      container: ".ais-hits-container",
      templates: {
        item(hit, { html, components }) {
          return algolia.instantSearchProductTemplate(hit, html, components)
        },
        empty(results, { html }) {
          return algolia.instantSearchNoResultTemplate(html, results)
        },
        showMoreText(data, { html }) {
          return html`<a class="button_inner button--flip button--underline-strike typo__button-1 inline-block button--black" data-text="Load More"
            ><span>Load More</span></a
          >`
        }
      },
      transformItems: function (items) {
        //update number of hits per page
        document.querySelector(".ais--view-products-count").innerHTML = instant.search.helper.lastResults.nbHits
        //expand filters on initial page load
        if (algolia.helpers.isTabletUp()) algolia.helpers.expandFilters()
        //map items
        return items.map((item) => ({
          ...item,
          _distinct: instant.distinct,
          can_order: item.inventory_management !== "shopify" || item.inventory_policy === "continue" || item.inventory_quantity > 0,
          queryID: item.__queryID,
          productPosition: item.__position,
          index: instant.search.mainIndex.getIndexName()
        }))
      }
    })
  ])

  // trending searches
  instant.search.addWidgets([
    instantsearch.widgets.trendingItems({
      container: ".ais-hit-empty--trending-searches",
      templates: {
        item(item, { html }) {
          return html` <a href="/search?q=${item.title}">${item.title}</a>`
        }
      }
    })
  ])

  // blogs
  instant.search.addWidgets([
    instantsearch.widgets
      .index({
        indexName: algolia.config.index_prefix + "articles"
      })
      .addWidgets([
        infiniteHits({
          container: ".ais-main-blogs",
          templates: {
            item(hit, { html, components }) {
              return algolia.instantSearchBlogsTemplate(hit, html, components)
            },
            empty(results, { html }) {
              return algolia.instantSearchBlogsEmptyTemplate(html, results)
            },
            showMoreText(data, { html }) {
              return html`<a
                class="button_inner button--flip button--underline-strike typo__button-1 inline-block button--black"
                data-text="Load More"
                ><span>Load More</span></a
              >`
            }
          },
          transformItems: function (items, { results }) {
            document.querySelector(".ais--view-blogs-count").innerHTML = results.nbHits
            return items.map((item) => ({
              ...item,
              _distinct: instant.distinct,
              can_order: item.inventory_management !== "shopify" || item.inventory_policy === "continue" || item.inventory_quantity > 0,
              queryID: item.__queryID,
              productPosition: item.__position,
              index: algolia.config.index_prefix + "articles"
            }))
          }
        }),
        sortBy({
          container: ".ais-sort-orders-blogs-container",
          items: [
            {
              label: "Relevance",
              value: algolia.config.index_prefix + "articles"
            },
            {
              label: "Published (earliest)",
              value: algolia.config.index_prefix + "articles_published_at_desc"
            },
            {
              label: "Published (latest)",
              value: algolia.config.index_prefix + "articles_published_at_asc"
            }
          ]
        })
      ])
  ])

  // Customize infiniteHits UI
  // Create the render function
  let lastRenderArgs
  const renderInfiniteHits = (renderOptions, isFirstRender) => {
    const { hits, widgetParams, showPrevious, isFirstPage, showMore, isLastPage } = renderOptions
    const { container } = widgetParams
    lastRenderArgs = renderOptions

    // infinite scroll
    if (isFirstRender) {
      const sentinel = document.querySelector(".load-more-intersection")
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          sentinel.firstChild.classList.remove("hide")
          if (entry.isIntersecting && !lastRenderArgs.isLastPage) {
            window.setTimeout(() => {
              showMore()
            }, 500)
          } else if (entry.isIntersecting && lastRenderArgs.isLastPage) {
            // hide infinite scroll loader
            sentinel.firstChild.classList.add("hide")
          }
        })
      })
      observer.observe(sentinel)
      return
    }
  }
  // // Create the custom widget
  // const customInfiniteHits = connectInfiniteHits(renderInfiniteHits)
  // // Instantiate the custom widget
  // instant.search.addWidgets([
  //   customInfiniteHits({
  //     container: document.querySelector(".ais-hits-container"),
  //     showPrevious: true
  //   })
  // ])

  // Redirect to product on click
  instant.search.addWidgets([
    {
      init: function () {
        var container = document.querySelector(".ais-hits-container")
        container.addEventListener("click", function (e) {
          var el = e.target
          var hit
          do {
            if (el.matches(".ais-hit")) {
              hit = el
              break
            }
            el = el.parentNode
          } while (el && el !== container)
          // cancel the click if the user is clicking slider
          var el = e.target
          do {
            if (el.matches(".splide__arrows") || el.matches(".splide__pagination") || el.matches(".video__toggle")) {
              hit = false
              break
            }
            el = el.parentNode
          } while (el && el !== container)

          if (!hit) {
            return
          }
          var $this = hit
          var productHandle = $this.dataset.handle
          var variant_id = $this.dataset.variantId
          var distinct = $this.dataset.distinct

          // Construct the link we should redirect to
          var link = ""

          // If we're on a collection page and the handle is available
          // then prefix the product link with the collection handle
          if (collectionPageEnabled && collectionHandle) {
            link = "/collections/" + collectionHandle
          }

          // Add the product handle to the link
          link = link + "/products/" + productHandle

          // Add the variant ID details to redirect to a specific
          // variant ID if we are showing variants and not products
          if (distinct !== "true") {
            link += "?variant=" + variant_id
          }

          if (algolia.config.analytics_enabled) {
            //Retrieving userToken
            let userToken
            insightsClient("getUserToken", null, (err, newUserToken) => {
              if (err) {
                console.error(err)
                return
              }
              userToken = newUserToken
            })

            var clickData = {
              userToken,
              index: hit.dataset.algoliaIndex,
              eventName: "click",
              queryID: hit.dataset.algoliaQueryid,
              objectIDs: [hit.dataset.algoliaObjectid],
              positions: [Number(hit.dataset.algoliaPosition)]
            }

            // Send the click event
            insightsClient("clickedObjectIDsAfterSearch", clickData)
            /**
             * Uncomment the following function call to start storing data in
             * local storage for conversion tracking
             */
            algolia.saveForConversionTracking(clickData)
          }
          window.location.href = link
        })
      }
    }
  ])

  // Add to cart
  instant.search.addWidgets([
    {
      init: function () {
        var container = document.querySelector(".ais-hits-container")
        container.addEventListener("click", function (e) {
          var el = e.target
          var cartButton
          do {
            if (el.matches(".ais-hit--cart-button")) {
              cartButton = el
              break
            }
            el = el.parentNode
          } while (el && el !== container)
          if (!cartButton) {
            return
          }

          e.stopPropagation()
          var $this = cartButton
          var formId = $this.dataset.formId

          if (formId) {
            document.getElementById(formId).submit()
          }
        })
      }
    }
  ])

  // No result actions
  instant.search.addWidgets([
    {
      init: function (opts) {
        var container = document.querySelector(".ais-hits-container")
        container.addEventListener("click", function (e) {
          var el = e.target
          var clearFilters
          do {
            if (el.matches(".ais-hit-empty--clear-filters")) {
              clearFilters = el
              break
            }
            el = el.parentNode
          } while (el && el !== container)
          if (!clearFilters) {
            return
          }

          var helper = opts.helper
          helper.clearTags()
          instant.facets.list.forEach(function (facet) {
            helper.clearRefinements(facet.name)
          })
          helper.search()
        })

        container.addEventListener("click", function (e) {
          var el = e.target
          var clearInput
          do {
            if (el.matches(".ais-hit-empty--clear-input")) {
              clearInput = el
              break
            }
            el = el.parentNode
          } while (el && el !== container)
          if (!clearInput) {
            return
          }

          opts.helper.setQuery("").search()
          var input = document.querySelector(".ais-search-box--input")
          input.value = ""
          input.focus()
        })
      }
    }
  ])

  // custom sortBy render
  // Create the render function
  const renderSortBy = (renderOptions, isFirstRender) => {
    const {
      options,
      currentRefinement,
      refine,
      widgetParams,
      // `canRefine` is only available from v4.45.0
      // Use `hasNoResults` in earlier minor versions.
      canRefine
    } = renderOptions

    let j, a, b, c
    /* Look for any elements with the class "ais-SortBy": */
    const sortContainer = widgetParams.container.querySelector(".ais-SortBy")
    if (sortContainer !== null) {
      const selElmnt = sortContainer.querySelector("select")
      if (sortContainer.querySelector(".select-selected") === null) {
        /* For each element, create a new DIV that will act as the selected item: */
        a = document.createElement("DIV")
        a.setAttribute("class", "select-selected")
        a.setAttribute("tabindex", "0")
        const selectedItem =
          Array.from(selElmnt.options)
            .map((el) => ({ value: el.value, text: el.innerHTML }))
            .filter((option) => option.value == currentRefinement)[0] ?? null
        a.innerHTML = selectedItem ? selectedItem.text : ""
        a.setAttribute("aria-label", "Sort by " + a.innerHTML)
        sortContainer.appendChild(a)
        /* For each element, create a new DIV that will contain the option list: */
        b = document.createElement("DIV")
        b.setAttribute("class", "select-items select-hide")
        a.addEventListener("click", function (e) {
          /* When the select box is clicked, close any other select boxes,
              and open/close the current select box: */
          e.stopPropagation()
          closeAllSelect(this)
          this.nextSibling.classList.toggle("select-hide")
          this.classList.toggle("select-arrow-active")
        })
        a.addEventListener("keypress", function (e) {
          if (e.key == "Enter") {
            this.click()
          }
        })
      }
      if (sortContainer.querySelector(".select-items") === null) {
        for (j = 0; j < selElmnt.length; j++) {
          /* For each option in the original select element,
              create a new DIV that will act as an option item: */
          c = document.createElement("DIV")
          c.setAttribute("value", selElmnt.options[j].getAttribute("value"))
          c.setAttribute("tabindex", "0")
          c.innerHTML = selElmnt.options[j].innerHTML
          c.addEventListener("click", function (e) {
            /* When an item is clicked, update the original select box,
                  and the selected item: */
            var y, i, k, s, h, sl, yl
            s = this.parentNode.parentNode.getElementsByTagName("select")[0]
            sl = s.length
            h = this.parentNode.previousSibling
            for (i = 0; i < sl; i++) {
              if (s.options[i].innerHTML == this.innerHTML) {
                s.selectedIndex = i
                h.innerHTML = this.innerHTML
                h.setAttribute("aria-label", "Sort by " + h.innerHTML)
                y = this.parentNode.getElementsByClassName("same-as-selected")
                yl = y.length
                for (k = 0; k < yl; k++) {
                  y[k].removeAttribute("class")
                }
                this.setAttribute("class", "same-as-selected")
                break
              }
            }
            // in original select el choose the same option
            selElmnt.querySelector("option[value=" + e.target.getAttribute("value") + "]").click()
            selElmnt.dispatchEvent(new Event("change"))
          })
          c.addEventListener("keypress", function (e) {
            if (e.key == "Enter") {
              this.click()
            }
          })
          b.appendChild(c)
        }
        sortContainer.appendChild(b)
      }
    }

    function closeAllSelect(elmnt) {
      /* A function that will close all select boxes in the document,
        except the current select box: */
      var x,
        y,
        i,
        xl,
        yl,
        arrNo = []
      x = document.getElementsByClassName("select-items")
      y = document.getElementsByClassName("select-selected")
      xl = x.length
      yl = y.length
      for (i = 0; i < yl; i++) {
        if (elmnt == y[i]) {
          arrNo.push(i)
        } else {
          y[i].classList.remove("select-arrow-active")
        }
      }
      for (i = 0; i < xl; i++) {
        if (arrNo.indexOf(i)) {
          x[i].classList.add("select-hide")
        }
      }
    }

    /* If the user clicks anywhere outside the select box,
      then close all select boxes: */
    document.addEventListener("click", closeAllSelect)
  }
  // Create the custom widget
  const customSortBy = connectSortBy(renderSortBy)
  // Instantiate the custom widget
  instant.search.addWidgets([
    customSortBy({
      container: document.querySelector(".ais-sort-orders-container"),
      items: instant.sortOrders
    }),
    customSortBy({
      container: document.querySelector(".ais-sort-orders-blogs-container"),
      items: [
        {
          label: "Relevance",
          value: algolia.config.index_prefix + "articles"
        },
        {
          label: "Published (earliest)",
          value: algolia.config.index_prefix + "articles_published_at_desc"
        },
        {
          label: "Published (latest)",
          value: algolia.config.index_prefix + "articles_published_at_asc"
        }
      ]
    })
  ])
  let searchHeader = document.querySelector(".ais-search-header")
  // Pagination
  instant.search.addWidgets([
    pagination({
      container: ".ais-pagination-container",
      scrollTo: searchHeader,
      padding: 2,
      maxPages: 20
    })
  ])

  // Main
  // This prevents a second request to be made to Algolia when the userToken (using cookies) gets set. The first request is sent only when the userToken is set.
  function checkUserToken() {
    if (!algolia.userTokenCheck) {
      window.setTimeout(checkUserToken, 10) /* this checks the flag every 10 milliseconds*/
    } else {
      instant.search.start()
      firstRender = false
    }
  }

  if (algolia.config.analytics_enabled && algolia.config.usertoken_with_cookies === "enabled" && firstRender) {
    checkUserToken()
  } else {
    instant.search.start()
  }

  algolia.contentHide.parentNode.removeChild(algolia.contentHide)

  // algolia_instant_search.js.liquid ================================================================>
})(window.algoliaShopify)
